import EditorActions from './editor_actions';

export default EditorActions;
